export default function checkauth({ next, store }) {
    // Our token expires, try to expire gracefully
    let user = store.getters.getUser();
    let now = new Date();
    if(user.expires) {
       if(user.expires < now) {
           // Token expired
           store.setUser({
            loggedIn: false,
            name: '',
            ccid: '',
            expires: false,
        });
       }
       else {
            return next();
       }
    }

    store.dispatch('logout')
    return next({
        name: 'home'
    })
}